module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sea-shore@3x_64534e.jpg";